module.exports = __webpack_public_path__ + "img/SALT.7e6cc5c6.svg";